module.exports = __webpack_public_path__ + "static/senior-10-2138da2e9525620c935c509adde9986e.jpg";